import { render, staticRenderFns } from "./image-editor.vue?vue&type=template&id=3153861a&scoped=true"
import script from "./image-editor.vue?vue&type=script&lang=js"
export * from "./image-editor.vue?vue&type=script&lang=js"
import style0 from "./image-editor.vue?vue&type=style&index=0&id=3153861a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153861a",
  null
  
)

export default component.exports